import React, { useContext, useEffect, useState } from "react";
import venomContext from "../../context/venomContext";
import { toast } from "react-toastify";
// import { useNavigate, useOutletContext } from "react-router-dom";
// import { confirmAlert } from "react-confirm-alert"; // Import
// import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import classNames from "classnames";

export default function AllUsers({
  setAlertIsActive,
  setActionName,
  setAccountID,
}) {
  // const navigate = useNavigate();
  const context = useContext(venomContext);
  const {
    currentUser,
    getTotalUsers,
    usersTotal,
    createUserByAdmin,
    updateUserInfo,
    // deleteUserByAdmin,
    // allBlogs,
    // allCategories,
  } = context;
  // const { isFirst, role } = currentUser;
  const [isEdited, setIsEdited] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [userInfo, setUserInfo] = useState({
    user_name: "",
    user_email: "",
    role: "",
  });
  const [userProfile, setUserProfile] = useState({ user_profile: "" });
  const { users } = usersTotal;
  const [currentInfo, setCurrentInfo] = useState({
    id: "",
    current_name: "",
    current_role: "",
    current_user_profile: "",
  });
  const theme_color = localStorage.getItem("theme");
  const onChangeHandler = (e) => {
    setUserInfo({ ...userInfo, [e.target.name]: e.target.value });
  };
  const fileChangeHandler = (e) => {
    let file = e.target.files[0];
    let fileSize = file.size;
    let fileMB = fileSize / 1024 ** 2;
    console.log(fileMB.toFixed(2));
    if (fileMB >= 0.5) {
      setUserProfile({ user_profile: "" });
      return toast.warning("File size should be less than 500KB", {
        position: "bottom-right",
      });
    }
    let reader = new FileReader();
    reader.onload = () => {
      setUserProfile({ [e.target.name]: reader.result });
    };
    reader.readAsDataURL(file);
  };
  const createUserHandler = () => {
    const { user_name, user_email, role } = userInfo;
    const { user_profile } = userProfile;
    if (isEdited === false) {
      if (!user_email || !user_profile) {
        return toast.warn("All Fields are required", {
          position: "bottom-right",
        });
      }
      createUserByAdmin(user_email, user_profile, role);
      setUserProfile({ user_profile: "" });
      setUserInfo({ user_email: "", role: "" });
      document.getElementById("user_profile").value = "";
      document.getElementById("role").value = "";
      document.getElementById("user_email").value = "";
      return;
    }
    const { id, current_name, current_role, current_user_profile } =
      currentInfo;
    updateUserInfo(
      id,
      user_name ? user_name : current_name,
      role ? role : current_role,
      user_profile ? user_profile : current_user_profile
    );
  };
  useEffect(() => {
    getTotalUsers();
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <div className="blogs-all d-flex justify-content-between align-items-center mt-4">
        <h3
          className={classNames("m-0", {
            "text-light": localStorage.getItem("mode") === "dark",
          })}
        >
          All Users
        </h3>
        <div className="right-content">
          <i
            className="fas fa-sync me-3"
            style={{ cursor: "pointer" }}
            onClick={async (e) => {
              e.target.classList.add("active");
              await getTotalUsers();
              e.target.classList.remove("active");
              toast.success("User records has been updated.", {
                position: "bottom-right",
              });
            }}
          ></i>
          <button
            className={"btn btn-md btn-" + theme_color}
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
            onClick={() => {
              setIsNew(true);
            }}
          >
            Create User
          </button>
        </div>
      </div>
      <div className="tabular-data">
        <table className="table table-bordered align-middle table-striped table-hover mt-3">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Profile</th>
              <th scope="col">Name</th>
              <th scope="col">Email</th>
              <th scope="col">Role</th>
              <th scope="col">Updated at</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            {!users && (
              <tr>
                <td colSpan={7} className="text-center">
                  <h6 className="m-0">No Users Found</h6>
                </td>
              </tr>
            )}
            {users &&
              users.map((curElem, index) => {
                const { _id, name, email, profile, role, updatedAt, isFirst } =
                  curElem;
                var date = new Date(updatedAt);
                let splitedDate = date.toString().split(" ");
                let month = splitedDate[1];
                let day = splitedDate[2];
                let year = splitedDate[3];
                var hours = date.getHours();
                var minutes = date.getMinutes();
                var ampm = hours >= 12 ? "pm" : "am";
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                hours = hours < 10 ? "0" + hours : hours;
                minutes = minutes < 10 ? "0" + minutes : minutes;
                var dateTime =
                  month +
                  ", " +
                  day +
                  " " +
                  year +
                  " at " +
                  hours +
                  ":" +
                  minutes +
                  " " +
                  ampm;
                return (
                  <tr key={_id}>
                    <th scope="row">{index + 1}</th>
                    <td>
                      <img
                        src={profile}
                        style={{ width: 40, objectFit: "cover" }}
                        alt=""
                      />
                    </td>
                    <td>{name}</td>
                    <td>{email}</td>
                    <td>{role}</td>
                    <td>{dateTime}</td>
                    <td colSpan="2">
                      {role === "admin" && isFirst === true ? (
                        ""
                      ) : (
                        <>
                          {isFirst === false && (
                            <i
                              className="fas fa-edit me-2"
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModal"
                              style={{
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setIsEdited(true);
                                setCurrentInfo({
                                  id: _id,
                                  current_name: name,
                                  current_role: role,
                                  current_user_profile: profile,
                                });
                              }}
                            ></i>
                          )}
                        </>
                      )}
                      {role === "admin" &&
                      isFirst === true &&
                      currentUser.isFirst === true ? (
                        <i
                          className="fas fa-trash-alt"
                          style={{ cursor: "pointer" }}
                          onClick={async (e) => {
                            e.target.classList.remove("fa-trash-alt");
                            e.target.classList.add("fa-sync", "active");
                            setAlertIsActive(true);
                            setActionName("delete admin account");
                            setAccountID(_id);
                            e.target.classList.add("fa-trash-alt");
                            e.target.classList.remove("fa-sync", "active");
                          }}
                        ></i>
                      ) : (
                        <>
                          {isFirst === false && (
                            <i
                              className="fas fa-trash-alt"
                              style={{ cursor: "pointer" }}
                              onClick={async (e) => {
                                e.target.classList.remove("fa-trash-alt");
                                e.target.classList.add("fa-sync", "active");
                                setAlertIsActive(true);
                                setActionName("delete user account");
                                setAccountID(_id);
                                e.target.classList.add("fa-trash-alt");
                                e.target.classList.remove("fa-sync", "active");
                              }}
                            ></i>
                          )}
                        </>
                      )}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>

      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {isEdited === true ? "Update User" : "Create User"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setIsEdited(false);
                  setIsNew(false);
                  setCurrentInfo({
                    id: "",
                    current_name: "",
                    current_role: "",
                    current_user_profile: "",
                  });
                  setUserInfo({ user_name: "", user_email: "", role: "" });
                  setUserProfile({ user_profile: "" });
                  document.getElementById("user_profile").value = "";
                  // document.getElementById("role").value = "";
                  // document.getElementById("user_email").value = "";
                }}
              ></button>
            </div>
            <div className="modal-body">
              <div className="blog-form">
                {isEdited === true && isNew === false ? (
                  <div className="form-group">
                    <label htmlFor="user_name">User Name</label>
                    <input
                      type="text"
                      value={
                        userInfo.user_name === ""
                          ? currentInfo.current_name
                          : userInfo.user_name
                      }
                      name="user_name"
                      onChange={onChangeHandler}
                      className={"form-control my-2 input-" + theme_color}
                      id="user_name"
                    />
                  </div>
                ) : (
                  <div className="form-group">
                    <label htmlFor="user_email">User Email</label>
                    <input
                      type="email"
                      value={userInfo.user_email}
                      name="user_email"
                      onChange={onChangeHandler}
                      className={"form-control my-2 input-" + theme_color}
                      id="user_email"
                    />
                  </div>
                )}
                <div className="form-group">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="w-100">
                      <label htmlFor="user_profile">User Profile</label>
                      <input
                        type="file"
                        // value={catName.cat_name}
                        name="user_profile"
                        onChange={fileChangeHandler}
                        className={"form-control my-2 input-" + theme_color}
                        id="user_profile"
                      />
                    </div>
                    {isEdited === true && isNew === false && (
                      <div
                        className={classNames("img-preview", {
                          "ms-3": currentInfo.current_user_profile,
                        })}
                      >
                        <img
                          className="ms-3"
                          style={{ height: 50, marginTop: 15 }}
                          src={
                            userProfile.user_profile === ""
                              ? currentInfo.current_user_profile
                              : userProfile.user_profile
                          }
                          alt=""
                        />
                      </div>
                    )}
                    {isNew === true && isEdited === false && (
                      <>
                        {userProfile.user_profile !== "" && (
                          <div
                            className={classNames("img-preview", {
                              "ms-3": userProfile.user_profile !== "",
                            })}
                          >
                            <img
                              style={{ height: 50, marginTop: 15 }}
                              src={userProfile.user_profile}
                              alt=""
                            />
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="role">User Role</label>
                  <select
                    name="role"
                    value={
                      userInfo.role === ""
                        ? currentInfo.current_role
                        : userInfo.role
                    }
                    onChange={onChangeHandler}
                    className={"form-control my-2 input-" + theme_color}
                    id="role"
                  >
                    <option value="" selected disabled>
                      Select Role
                    </option>
                    <option value="user">User</option>
                    <option value="admin">Admin</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                // ref={refClose}
                type="button"
                onClick={() => {
                  // resetModelHandler();
                  setIsEdited(false);
                  setIsNew(false);
                  setCurrentInfo({
                    id: "",
                    current_name: "",
                    current_role: "",
                    current_user_profile: "",
                  });
                  setUserInfo({ user_name: "", user_email: "", role: "" });
                  setUserProfile({ user_profile: "" });
                  document.getElementById("user_profile").value = "";
                  // document.getElementById("role").value = "";
                  // document.getElementById("user_email").value = "";
                }}
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                onClick={() => {
                  createUserHandler();
                  setIsEdited(false);
                  setIsNew(false);
                  setCurrentInfo({
                    id: "",
                    current_name: "",
                    current_role: "",
                    current_user_profile: "",
                  });
                  setUserInfo({ user_name: "", user_email: "", role: "" });
                  setUserProfile({ user_profile: "" });
                  document.getElementById("user_profile").value = "";
                  // document.getElementById("role").value = "";
                  // document.getElementById("user_email").value = "";
                  setTimeout(async () => {
                    await getTotalUsers();
                  }, 3000);
                }}
                type="button"
                disabled={
                  isEdited === true
                    ? !currentInfo.current_name ||
                      !currentInfo.current_user_profile ||
                      !currentInfo.current_role
                    : !userInfo.user_email ||
                      !userProfile.user_profile ||
                      !userInfo.role
                }
                className={"btn btn-" + theme_color}
                data-bs-dismiss="modal"
              >
                <i className="fal fa-spinner-third me-2 loading d-none"></i>
                {isEdited === true ? "Update User" : "Create User"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
